export const urlApi = process.env.REACT_APP_URLAPI;
export const urlwsRT =
  process.env.REACT_APP_ENV === 'local'
    ? `${process.env.REACT_APP_WSRT}/notificaciones`
    : `${process.env.REACT_APP_WSRT}/notificaciones`;
export const urlwsChat = process.env.REACT_APP_WSCHAT;
export const socketUbidots = process.env.REACT_APP_SOCKET_UBIDOTS;
export const urlUbidots = process.env.REACT_APP_URL_UBIDOTS;
